import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppQrCodeThumbComponent } from '../components/thumb/upp-thumb';
import { UppQrCodeSelectComponent } from '../components/select/upp-select';
import { UppQrCodeTicketComponent } from '../components/ticket/upp-ticket';
import { UppTableEditComponent } from '../components/edit/upp-edit';
import { UppQrCodeMatchComponent } from '../components/match/upp-match';
import { UppQrCodeAssignComponent } from '../components/assign/upp-assign';

@NgModule({
    declarations: [
        UppQrCodeThumbComponent,
        UppQrCodeSelectComponent,
        UppQrCodeTicketComponent,
        UppTableEditComponent,
        UppQrCodeMatchComponent,
        UppQrCodeAssignComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
    ],
    exports: [
        UppQrCodeThumbComponent,
        UppQrCodeSelectComponent,
        UppQrCodeTicketComponent,
        UppTableEditComponent,
        UppQrCodeMatchComponent,
        UppQrCodeAssignComponent,
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureQrCodeModule {}

